/** The nine-dot Sonasi mark on the brand disc. */
export function LogoMark({ size = 28 }: { size?: number }) {
  const glyph = Math.round(size * 0.68);
  return (
    <span
      className="flex flex-none items-center justify-center rounded-full"
      style={{ width: size, height: size, background: 'var(--brand)' }}
    >
      <svg width={glyph} height={glyph} viewBox="0 0 64 64" fill="none" aria-hidden="true">
        {[15, 32, 49].map((cy) =>
          [15, 32, 49].map((cx) =>
            cx === 32 && cy === 32 ? (
              <circle key={`${cx}-${cy}`} cx={32} cy={32} r={10} fill="#f7f4f2" />
            ) : (
              <circle key={`${cx}-${cy}`} cx={cx} cy={cy} r={6} fill="#f7f4f2" opacity={0.85} />
            ),
          ),
        )}
      </svg>
    </span>
  );
}
